module.exports = require("@swa-ui/core/src/Pulse/Pulse.module.scss");